module.exports = __webpack_public_path__ + "img/the_life_changing.99b240a9.jpg";